export const isCardCreating = (status?: string | null) =>
	(status || "").toLowerCase() === "created"

export const isCardPermanentlyBlocked = (status?: string | null) =>
	["blocked", "closed"].includes((status || "").toLowerCase())

export const preservePermanentCardStatus = <T extends { uid: string; status: string }>(
	known: Pick<T, "uid" | "status"> | undefined, incoming: T
): T => known?.uid === incoming.uid && isCardPermanentlyBlocked(known.status) && !isCardPermanentlyBlocked(incoming.status)
	? { ...incoming, status: known.status } : incoming

export const getCardStatusDisplayLabel = (status?: string | null) => {
	if (!status) return "N/A"
	if (isCardCreating(status)) return "creating"
	return status.replaceAll("_", " ")
}
